import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent } from 'vue'
import { NeoButton } from '@kodadot1/brick'


export default /*#__PURE__*/_defineComponent({
  __name: 'IdentityItem',
  props: {
    label: null,
    account: null,
    prefix: null,
    variant: { default: 'normal' },
    buttonLabel: { default: 'View Profile' }
  },
  setup(__props: any) {

const Identity = defineAsyncComponent(
  () => import('@/components/identity/IdentityIndex.vue')
)



return { __sfc: true,Identity, NeoButton }
}

})